import { render, staticRenderFns } from "./Average.vue?vue&type=template&id=97249ce6&scoped=true&"
import script from "./Average.vue?vue&type=script&lang=js&"
export * from "./Average.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97249ce6",
  null
  
)

export default component.exports